import axios, { rawAxios } from '@/lib/axios'
import { buildAdminRequestConfig } from '@/lib/organization-scoping'
import type { ReportExportRequest, ReportQueryKeyEntries } from '@/lib/services/reports/reports.api'
import type { QueryFunctionContext } from '@tanstack/react-query'
import type { PlatformLedgerReportFilters } from './platform-ledger.schema'
import type {
  PlatformLedgerEntriesReport,
  PlatformLedgerSummaryReport,
} from './platform-ledger.types'

/** `PlatformLedgerSummaryRequest`: the API defaults a missing range to this month. */
export interface PlatformLedgerSummaryFilters {
  start_date?: string
  end_date?: string
}

/** Platform ledger fetchers read only the query key. */
type PlatformLedgerQueryContext<TFilters> = Pick<
  QueryFunctionContext<[ReportQueryKeyEntries<TFilters>]>,
  'queryKey'
>

export async function getPlatformLedgerSummary({
  queryKey: [{ organizationId, filters }],
}: PlatformLedgerQueryContext<PlatformLedgerSummaryFilters>) {
  return axios.get<PlatformLedgerSummaryReport>(
    '/platform-ledger/summary',
    buildAdminRequestConfig({ organizationId, params: { ...filters } })
  )
}

export async function getPlatformLedgerEntries({
  queryKey: [{ organizationId, filters }],
}: PlatformLedgerQueryContext<PlatformLedgerReportFilters>) {
  return axios.get<PlatformLedgerEntriesReport>(
    '/platform-ledger/entries',
    buildAdminRequestConfig({ organizationId, params: { ...filters } })
  )
}

export async function exportPlatformLedgerEntries({
  organizationId,
  filters,
}: ReportExportRequest<PlatformLedgerReportFilters>) {
  return rawAxios.get<Blob>(
    '/platform-ledger/entries/export',
    buildAdminRequestConfig({
      organizationId,
      headers: {
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
      params: { ...filters },
      responseType: 'blob',
    })
  )
}
